import {BasicEntity, BasicProperty} from "../../basic-entity-back/annotations";
import {PropertyType} from "../../basic-entity-back/property-type/property-type";
import {PropertyMap, ReadWrite} from "../../basic-entity-back/basic-entity-interface/mapping-external";
import {BaseEntity} from "../base-entity.model";
import {ArchivoSTLSolicitud} from "../archivos/archivo-stl-solicitud.model";
import {NestedBehavior} from "../../basic-entity-back/property-type/nested-model-type";
import {ArchivoSTLLineaSolicitud} from "../archivos/archivo-stl-linea-solicitud.model";
import {LineaSolicitud} from "./linea-solicitud.model";

@BasicEntity({
    name: 'Diseño STL de solicitudes',
    endpoint: 'diseno_solicituds',
    isPaginated: true,
    paginationSizes: [20, 30, 50],
    type: "DisenoSolicitud"
})
export class DisenoSolicitud extends BaseEntity {
    @BasicProperty({
        isId: true,
        name: 'ID',
        type: PropertyType.Integer()
    })
    private _id: number;

    public static readonly SOLICITUD_MAP: PropertyMap = {
        name: 'Solicitud',
        type: PropertyType.FutureUri('solicitud.model.ts')
    }
    @BasicProperty(DisenoSolicitud.SOLICITUD_MAP)
    private _solicitud;

    @BasicProperty({
        name: 'Archivo',
        type: PropertyType.NestedModel(ArchivoSTLSolicitud, 'disenoSolicitud', NestedBehavior.SendIriOnly),
        nullable: true
    })
    private _stlDiseno;

    get id(): number {
        return this._id;
    }

    set id(value: number) {
        this._id = value;
    }

    get solicitud() {
        return this._solicitud;
    }

    set solicitud(value) {
        this._solicitud = value;
    }

    get stlDiseno() {
        return this._stlDiseno;
    }

    set stlDiseno(value) {
        this._stlDiseno = value;
    }
}

ArchivoSTLSolicitud.SOLICITUD_MAP.type = PropertyType.Uri(DisenoSolicitud)
